var anime = window.anime;

var svg = document.getElementById("authorBlobSVG");

if (svg) {
  var blob = svg.getElementById("authorBlobImageMaskPath");

  var animation = anime({
    targets: blob,
    d: [
      {
        value: 'M71.9622 7.33132C78.1629 11.5659 81.4778 20.3375 86.1381 29.0285C90.779 37.7194 96.7653 46.3297 97.3892 55.3635C98.0132 64.4174 93.2554 73.915 86.8011 82.2026C80.3274 90.4702 72.1572 97.5076 63.402 98.1731C54.6468 98.8183 45.3261 93.0916 36.8049 88.6352C28.2643 84.1788 20.523 81.0331 14.5563 75.4273C8.60897 69.8417 4.43613 61.796 3.24667 53.3067C2.07671 44.8174 3.87065 35.8845 7.22452 27.4153C10.5784 18.9462 15.4727 10.9408 22.434 7.08934C29.4147 3.21773 38.4819 3.50004 47.5685 3.45971C56.6552 3.43954 65.7614 3.09674 71.9622 7.33132Z'
      },
      {
        value: 'M74.7221 11.7056C83.4087 17.2099 92.8956 21.7262 97.0925 29.2871C101.289 36.8681 100.177 47.4936 98.498 57.8973C96.8388 68.2808 94.6134 78.4628 88.7183 85.1768C82.8231 91.8908 73.2776 95.1772 63.7907 97.4556C54.3233 99.7339 44.934 101.024 37.1844 98.0201C29.4153 95.0159 23.2858 87.7374 16.1219 80.5798C8.95787 73.4222 0.778817 66.4259 0.0565615 58.5425C-0.685214 50.6792 6.01029 41.9288 11.8469 34.4486C17.6835 26.9886 22.6417 20.7786 28.8882 14.1049C35.1347 7.43122 42.6501 0.313958 50.3802 0.0115245C58.0907 -0.311071 66.016 6.20133 74.7221 11.7056Z'
      },
    ],
    easing: 'easeInOutSine',
    direction: 'alternate',
    duration: 2 * 5000,
    loop: true,
  });
}
